<div class="beachEffect"></div>
<div class="flex footerSpace">
  <div class="contentSpace">
    <div class="flex flexColumn">
      <div class="topFooter">
      </div>
      <div class="flex flexColumn">
        <div class="linePadding"><hr class="footerDivider" /></div>
        <div class="flex justify-content-between">
          <div class="flex flex-column ms-2">
            <div class="flex">&#169; Copyright 2025 - {{ currentYear }} Basilisk Technology.</div>
            <div class="flex">All Rights Reserved.</div>
            <div class="flex">Website by Basilisk Technology</div>
          </div>
          <div class="mt-2">
              <button mat-raised-button (click)="openDialog()">List your booking with Basilisk Technology</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
